/**
 * The "Custom" entry of the Session Type select. A custom lesson has no
 * booking option. When a user picks it, the form gives the lesson this length
 * and clears the price (the save sends 0).
 */
export const CUSTOM_SESSION_OPTION = {
  title: "Custom",
  id: null as number | null,
  duration: "60 mins",
  durationInMinutes: 60,
};
